export const styles = {
  formContainer: 'tw-space-y-6',
  formRow: 'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4',
  fullWidthField: 'tw-col-span-1 md:tw-col-span-2',
  loadingContainer: 'tw-py-12',
  selectWrapper: 'tw-min-w-0',
  pimsHeader: 'tw-flex tw-items-center tw-justify-between tw-mb-2',
  pimsHeaderLabel: 'tw-text-sm tw-font-medium tw-text-neutral-700',
  pimsList: 'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3',
  pimsRow:
    'tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded tw-border tw-border-neutral-200 tw-bg-neutral-50 tw-shadow-sm',
  pimsRowLabel: 'tw-text-sm tw-text-neutral-700 tw-min-w-0 tw-flex-1',
  scheduleAlert: 'tw-mb-4',
};
